export default "__VITE_ASSET__U4d5Kx5U__"